<template>
    <v-text-field 
        v-model="text" 
        placeholder="年/月/日" 
        dense 
        outlined 
        clearable
        v-disabled-icon-focus 
        readonly 
        v-slot:append 
        @click:clear="picker = null" 
        @click="menu = true" 
        background-color="white"
        class="search-text-picker"
        hide-details
    >
        <v-menu 
            v-model="menu" 
            offset-y 
            :close-on-content-click="false" 
            left
        >
            <template 
                v-slot:activator="{ on }"
            >
                <v-btn 
                    icon 
                    v-on="on" 
                    tabindex="-1"
                >
                    <v-icon>mdi-calendar</v-icon>
                </v-btn>
            </template>
            <v-date-picker
                v-model="picker"
                type="date"
                locale="jp-ja"
                color="teal accent-4"
                @click="menu = false"
                :day-format="date => new Date(date).getDate()"
            ></v-date-picker>
        </v-menu>
    </v-text-field>
</template>

<script>
    import moment from 'moment';
    export default {
        props: {
            defaultDate: String,
        },
        data() {
            return {
                menu: false,
                text: null,
            };
        },
        computed: {
            picker: {
                get() {
                    this.text =  this.defaultDate ? moment(this.defaultDate).format("YYYY/MM/DD"): this.picker = null;
                    return this.value;
                },
                set(val) {
                    this.menu = false;
                    this.$emit("input", val);
                }
            }
        }
    };
</script>

<style scoped>
    .search-text-picker::v-deep input {
        font-size: 1.5rem !important;
    }
    
    ::v-deep .search-text-picker {
        min-width: 165px !important;
    }
    
    .search-text-picker::v-deep .v-input__icon--clear {
        margin: -3px 8px 0px 0px !important;
    }
    
    .search-text-picker::v-deep .v-input__append-inner > .v-btn {
        width: 9px !important;
        margin-top: -14px;
    }
    .search-text-picker::v-deep .v-input__append-inner > .v-btn:before {
        background-color: transparent !important;
    }
        
    .search-text-picker ::v-deep .v-input__slot{
        height: 36px !important;
        min-height: 30px !important;
    }
    
    .mdi-calendar {
        padding-bottom: 10px;
    }
    
</style>